import styled from "styled-components";
import { ACCENT_PRIMARY_LIGHTEST } from "@streeteasy/design-system/colors";
import {
  PrimaryLarge,
  PrimarySmall
} from "@streeteasy/design-system/typography";

import { smallScreen } from "src/shared/constants/screenSizes";

import Section from "../Section";

export const SignInRegisterSection = styled(Section)`
  background-color: ${ACCENT_PRIMARY_LIGHTEST};
`;

export const Header = styled(PrimaryLarge).attrs({ as: "h2" })`
  margin-bottom: 8px;
`;

export const SubHeader = styled(PrimarySmall).attrs({ as: "h3" })`
  margin: auto;

  @media screen and (max-width: ${smallScreen}px) {
    max-width: 420px;
  }
`;

export const Img = styled.img.attrs({
  alt: "",
  "aria-hidden": true
})`
  display: block;
  margin: 0 auto 16px;

  @media screen and (max-width: ${smallScreen}px) {
    margin: 8px 16px;
  }
`;

export const Icons = styled.div`
  display: flex;
  margin: 0 auto;
  max-width: 1308px;
  padding: 56px 0 40px 0;
  width: 100%;

  @media screen and (max-width: ${smallScreen}px) {
    width: fit-content;
    text-align: left;
    flex-direction: column;
  }
}
`;

export const Icon = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;

  @media screen and (max-width: ${smallScreen}px) {
    align-items: center;
    flex-direction: row;
    justify-content: flex-start;
    width: fit-content;
  }
`;
